export default __webpack_public_path__ + "pdf/Alison_Young.75856cc.pdf";